import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { IconArrow } from "./Icons";

export function SectionHead({
  eyebrow,
  title,
  sub,
  center = false,
}: {
  eyebrow?: string;
  title: string;
  sub?: string;
  center?: boolean;
}) {
  return (
    <Reveal className={`section-head ${center ? "center" : ""}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {sub && <p>{sub}</p>}
    </Reveal>
  );
}

export function CtaBand({
  title = "Sẵn sàng để mỗi cuộc họp đều ra việc?",
  sub = "Đặt lịch demo để xem Ghi Âm Pro phiên âm, tóm tắt và sinh biên bản ngay trên dữ liệu họp của đơn vị bạn.",
}: {
  title?: string;
  sub?: string;
}) {
  return (
    <section className="section">
      <div className="container">
        <Reveal className="cta">
          <h2>{title}</h2>
          <p>{sub}</p>
          <div className="hero-cta">
            <Link to="/lien-he" className="btn btn-primary btn-lg">
              Yêu cầu demo <IconArrow size={18} />
            </Link>
            <Link to="/tinh-nang" className="btn btn-light btn-lg">
              Xem tính năng
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function PageHero({
  eyebrow,
  title,
  sub,
}: {
  eyebrow: string;
  title: string;
  sub: string;
}) {
  return (
    <section className="page-hero">
      <div className="container">
        <Reveal>
          <span className="eyebrow" style={{ color: "#8af0ff" }}>
            {eyebrow}
          </span>
          <h1>{title}</h1>
          <p>{sub}</p>
        </Reveal>
      </div>
    </section>
  );
}
